import { Link } from "react-router-dom";

const stats = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "3,000+", label: "剧情解析文章" },
  { value: "50万+", label: "月均读者" },
  { value: "每日", label: "实时更新" },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-center gap-8 px-4 md:px-6 lg:grid-cols-2 lg:gap-14">
        <div>
          <span className="mb-3 inline-block rounded-md bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
            关于肮脏的交易
          </span>
          <h2 className="text-xl font-bold text-foreground-950 md:text-3xl">
            用专业与耐心，讲好每一部影视作品的故事
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            肮脏的交易是一个专注影视作品资讯与剧情解析的门户平台。我们覆盖电影与电视剧两大类内容，提供权威、详尽且易于阅读的作品资料、剧情介绍与角色分析，帮助影迷快速了解作品卖点与细节。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们相信，好的解析能让一次观影变成一次真正的理解。无论是剧情脉络的梳理，还是角色动机的剖析，我们都希望让每一位影迷收获更深入的观影体验。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="flex items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line text-lg" />
              了解我们
            </Link>
            <Link
              to="/search"
              className="flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-lg" />
              开始搜索
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-5 text-center md:p-7"
            >
              <p className="text-2xl font-bold text-primary-600 md:text-3xl">{stat.value}</p>
              <p className="mt-2 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}